import React, { useEffect, useState } from "react";
import { BackToTop, Footer, NavItem, NavMenu, ToggleButton } from "../../Inicio/styles";
import { useLocation, useNavigate } from "react-router-dom";
import { SmokingsAzulesContainer } from "../styles";
import { ModelCard, ModelGrid, ModelImage, ModelInfo, ModelName } from "../../Trajes/Negros/styles";

const Sazules = () => {
    const [collapsed, setCollapsed] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    
    useEffect(() => {
                if(collapsed) {
                    document.body.style.overflow = "hidden";
                } else {
                    document.body.style.overflow = "auto";
                }
        
                return () => {
                    document.body.style.overflow = "auto";
                };
            }, [collapsed])
    

    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if(window.scrollY > 300) {
                setShowButton(true)
            } else {
                setShowButton(false)
            }
        }

        window.addEventListener("scroll", handleScroll)
        return () => window.removeEventListener("scroll", handleScroll)

    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    };

    return (
        <>
            <ToggleButton collapsed={collapsed} onClick={() => setCollapsed(!collapsed)}>
                {collapsed ? "✕" : "☰"}
            </ToggleButton>
            <NavMenu collapsed={collapsed}>
                <NavItem
                    active ={location.pathname === "/"}
                    onClick={() => navigate("/")}
                >
                    Inicio
                </NavItem>

                <NavItem
                    active = {location.pathname === "/trajes"}
                    onClick={() => navigate("/trajes")}
                >
                    Trajes
                </NavItem>

                <NavItem
                    active = {location.pathname.startsWith("/smokings")}
                    onClick={() => navigate("/smokings")}
                >
                    Smokings
                </NavItem>

                <NavItem
                    active = {location.pathname === "/togas"}
                    onClick={() => navigate("/togas")}
                >
                    Togas
                </NavItem>
                <NavItem>
                    <a
                        href="/catalogo-trajes"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Catálogo
                    </a>
                </NavItem>
                <NavItem><a href="https://wa.me/5213311407070" target="_blank" rel="noopener noreferrer">Contacto</a></NavItem>
            </NavMenu>
            
            <SmokingsAzulesContainer>
                <p>SMokings azules</p>
            </SmokingsAzulesContainer>

            <ModelGrid>
                <ModelCard>
                    <ModelImage 
                        src="/img/Torino-azul.jpg" alt="Torino azul"
                        onClick={() => navigate("/smokings/azules/torinoazul")}    
                    />
                    <ModelInfo>
                        <ModelName>Torino azul</ModelName>
                    </ModelInfo>
                </ModelCard>

                <ModelCard>
                    <ModelImage 
                        src="/img/Budapest.jpg" alt="Budapest"
                        onClick={() => navigate("/smokings/azules/budapest")}
                        />
                    <ModelInfo>
                        <ModelName>Budapest</ModelName>
                    </ModelInfo>
                </ModelCard>

                <ModelCard>
                    <ModelImage 
                        src="/img/Paris.jpg" alt="París"
                        onClick={() => navigate("/smokings/azules/paris")}
                    />
                    <ModelInfo>
                        <ModelName>París</ModelName>
                    </ModelInfo>
                </ModelCard>
            </ModelGrid>
            <Footer>
                <p>Eleganza Sartoriale</p>
                <p>Guadalajara, Jalisco</p>
                <div>
                    <a href="https://www.instagram.com/renta_de_trajes_mr?utm_source=qr&igsh=MW9pb2VwMnRmeW8zaw==">Intagram</a>
                    <a href="https://www.facebook.com/share/14WVJRCc3W4/">Facebook</a>
                    <a href="https://www.tiktok.com/@rentadetrajesmr?_r=1&_t=ZS-95BqJJ1lF7X">Tik Tok</a>
                </div>
                <div>
                    <p>© 2026 Renta de Trajes MR. Todos los derechos reservados.</p>
                </div>
            </Footer>
            {showButton && (
                <BackToTop onClick={scrollToTop}>
                    ▲
                </BackToTop>
            )}
        </>
    )
};

export default Sazules;